import { useRecoilValue } from 'recoil';
import { gql, useMutation } from '@apollo/client';
import { accountSelectedSelector } from 'atoms';
import { useMessages } from 'hooks';
import { UserAndContact } from 'types/UsersAndContact.types';
import { TFunction } from 'react-i18next';

const DELETE_CONTACT = gql`
  mutation DeleteContact(
    $masterCompanyId: Int!
    $isCloud: Boolean!
    $contactsIds: [Int]
    $token: String!
    $accountId: Int
    $webService: String
  ) {
    deleteContact(
      masterCompanyId: $masterCompanyId
      isCloud: $isCloud
      contactsIds: $contactsIds
      token: $token
      accountId: $accountId
      webService: $webService
    )
  }
`;

function useDeleteContact({
  t,
  item,
  setOpenDelete,
  refetchContacts,
}: {
  t: TFunction<('contacts' | '_common')[], undefined>;
  item: UserAndContact | null;
  setOpenDelete: React.Dispatch<React.SetStateAction<UserAndContact | boolean>>;
  refetchContacts: () => void;
}) {
  const accountSelected = useRecoilValue(accountSelectedSelector);
  const { enqueueError, enqueueSuccess } = useMessages();

  const [deleteContact, { loading }] = useMutation(DELETE_CONTACT, {
    variables: {
      ...accountSelected,
      token: '0',
      accountId: accountSelected?.id || 0,
      contactsIds: [item?.id || 0],
    },
    onCompleted: () => {
      enqueueSuccess(t('contacts:contact_deleted'));
      setOpenDelete(false);
      refetchContacts();
    },
    onError: () => {
      enqueueError(t('contacts:error_deleting_contact'));
    },
  });

  return {
    handleDelete: deleteContact,
    loading,
  };
}

export default useDeleteContact;
